import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { IndustriesShowcase } from '../components/landing/IndustriesShowcase';

const OG_META: Record<string, { title: string; description: string }> = {
  inmobiliaria: {
    title: 'Clientelo para Inmobiliarias · Demo',
    description: 'Agenda visitas, publica propiedades y cobra en línea. Prueba el demo.',
  },
  belleza: {
    title: 'Clientelo para Salones de Belleza · Demo',
    description: 'Reservas online, catálogo de servicios y créditos integrados para tu salón.',
  },
  gym: {
    title: 'Clientelo para Gimnasios y Artes Marciales · Demo',
    description: 'Membresías, clases, entrenador personal. Todo en un solo lugar.',
  },
  educacion: {
    title: 'Clientelo para Academias y Educación · Demo',
    description: 'Inscripciones, cursos y pagos online para tu academia.',
  },
  consultoria: {
    title: 'Clientelo para Consultoras · Demo',
    description: 'Agenda sesiones, gestiona clientes y cobra tus servicios profesionales.',
  },
  retail: {
    title: 'Clientelo para Tiendas de Moda · Demo',
    description: 'Catálogo digital, reservas y ventas para tu tienda.',
  },
  celulares: {
    title: 'Clientelo para Tiendas de Celulares · Demo',
    description: 'Vende smartphones, accesorios y ofrece arreglos. Demo interactivo.',
  },
};

const META_DEFAULT = {
  title: 'Clientelo · Demo de catálogo',
  description: 'Prueba cómo se ve tu catálogo público y reservas con Clientelo.',
};

/**
 * Ruta compartible `/demo/:industrySlug` — misma demo que la home, pestaña inicial por slug.
 */
const DemoPage: React.FC = () => {
  const { industrySlug } = useParams<{ industrySlug: string }>();
  const key = industrySlug?.toLowerCase().trim() ?? '';
  const meta = OG_META[key] ?? META_DEFAULT;

  useEffect(() => {
    const t = window.setTimeout(() => {
      document.getElementById('funcionalidades')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 150);
    return () => window.clearTimeout(t);
  }, []);

  useEffect(() => {
    const prevTitle = document.title;
    const descEl = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const prevDesc = descEl?.getAttribute('content') ?? null;

    document.title = meta.title;
    if (descEl) descEl.setAttribute('content', meta.description);

    return () => {
      document.title = prevTitle;
      if (descEl && prevDesc !== null) descEl.setAttribute('content', prevDesc);
    };
  }, [meta.description, meta.title]);

  return (
    <>
      <header className="flex items-center justify-between px-4 sm:px-6 py-4 border-b border-gray-200 bg-white">
        <Link to="/" className="flex items-center gap-2 font-bold text-lg text-[#0B1F4A] hover:opacity-90">
          <span aria-hidden>🧾</span>
          Clientelo
        </Link>
        <a
          href="/#precios"
          className="text-sm font-semibold text-white bg-[#1A56DB] hover:bg-[#154abf] px-4 py-2 rounded-lg transition-colors"
        >
          Ver planes
        </a>
      </header>

      <main id="funcionalidades" className="bg-gray-50 min-h-[calc(100vh-4rem)]">
        <IndustriesShowcase initialSlug={industrySlug} />
      </main>
    </>
  );
};

export default DemoPage;
